import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import PropTypes from "prop-types";

// TAD-5644 — Vite-native SVG-as-component via `?react` query suffix
// (vite-plugin-svgr). Vitest goes through the same Vite transform, so this
// works in tests too.
import WelcomeMSWordImg from "../../assets/img/welcome-msword-330px.svg?react";
import WelcomeMSPowerpointImg from "../../assets/img/welcome-mspowerpoint-330px.svg?react";

import "./WelcomeScreen.scss";

const getImage = (extension) => {
    switch (extension) {
        case "docx":
            return <WelcomeMSWordImg className="file-icon" />;
        case "pptx":
            return <WelcomeMSPowerpointImg className="file-icon" />;
        default:
            return <WelcomeMSWordImg className="file-icon" />;
    }
}

// This component is the welcome page that -> request the user to continue their experience in word or power point
// Right now is been used in DC create task and DC edit and final edit (actions/task panel)
const WelcomeScreen = ({documentName, onClick}) => {
    const extension = documentName.toLowerCase().substring(documentName.lastIndexOf('.')+1, documentName.length) || documentName;
    return (
        <React.Fragment>
            <Container className="welcome-screen-container">
                <Row className="justify-content-md-center">
                    <h3 className="welcome-title">
                        Your Experience will continue on
                    </h3>
                </Row>
                <Row className="justify-content-md-center">
                    <h3 className={`welcome-sub-title ${extension}`}>
                        {`Microsoft ${extension==="pptx"? "Power Point" : "Word"}`}
                    </h3>
                </Row>
                <Row className="justify-content-md-center">
                    {getImage(extension)}
                </Row>
                <Row className="justify-content-md-center">
                    <span className="welcome-footer">
                        <button className="button-download-link" onClick={onClick}>Not Started? Click here to download</button>
                    </span>
                </Row>
            </Container>
        </React.Fragment>
    );
}

WelcomeScreen.propTypes = {
    documentName: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired
}

export default WelcomeScreen;
